import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { cds } from '../../scripts/cds';
import emitter from '../../scripts/eventEmitter';
import { Dropdown, Select, Switch } from 'antd';
import { trans } from '../../scripts/translate';

var updateTimeout = null;
var initialTimeout = null;

function Coupon({ sticky = false, setOpened }) {
    const [data, setData] = useState(null);
    const [amount, setAmount] = useState(1);
    const [lastAmount, setLastAmount] = useState(1);
    const [inCoupon, setInCoupon] = useState([]);
    const [playing, setPlaying] = useState(false);
    const [played, setPlayed] = useState(false);
    const [lastCouponId, setLastCouponId] = useState(0);
    const [settingsOpen, setSettingsOpen] = useState(false);
    const [rememberSelections, setRememberSelections] = useState(localStorage.getItem('rememberSelections') === 'true');
    const [acceptOddChanges, setAcceptOddChanges] = useState(localStorage.getItem('acceptOddChanges') !== 'false');
    const settingsRef = useRef();

    const setCouponData = (data) => {

        // hata mı var?
        if (data.status == 'error') {
            emitter.emit('error', data.message);
            return;
        }
        setData(data);
        emitter.emit('setBetCount', data.coupon.bets.length);
        var in_coupon = [];
        data.coupon.bets.forEach(bet => {
            in_coupon.push(bet.event_id+'_'+bet.category_id+'_'+bet.option_id);
        });
        setInCoupon(in_coupon);
        emitter.emit('inCoupon', in_coupon);
        setAmount(data.coupon.amount);
    };

    const clearCoupon = () => {
        cds('coupon/clear').then(json => {
            setCouponData(json);
            emitter.emit('success', 'Kuponunuz temizlendi.');
            setOpened(false);
        });
    };

    const deleteBet = (event_id, category_id, option_id) => {
        cds('coupon/delete-bet', {
            method: 'POST',
            body: { event_id: event_id, category_id: category_id, option_id: option_id }
        }).then(json => {
            setCouponData(json);
        })
    };

    const getPlayStatus = () => {
        cds('coupon/play-status', {
            method: 'POST',
            body: { played_coupon_id: 0 }
        }).then(json => {
            if (json.status == 'success') {
                if (json.completed == true) {
                    setCouponData(json);
                    setPlaying(false);
                    setPlayed(true);
                    emitter.emit('success', 'Bahsiniz alınmıştır, iyi şanslar dileriz.');
                    setLastCouponId(json.played_coupon_id);
                } else {
                    setTimeout(() => {
                        getPlayStatus();
                    }, 3000);
                }
            } else {
                emitter.emit('error', json.message);
            }
        });
    };

    const play = () => {
        setPlaying(true);
        cds('coupon/play', {
            method: 'POST',
            body: { amount: amount }
        }).then(json => {
            if (json == '505') {
                setTimeout(() => {
                    getPlayStatus();
                }, 3000);
                return;
            }
            setCouponData(json);
            setPlaying(false);
            if (json.hasOwnProperty('played_coupon_id')) {
                emitter.emit('success', 'Kuponunuz başarıyla yatırılmıştır. Bol şans dileriz..');
                setPlayed(true);
                setLastCouponId(json.played_coupon_id);
            }
        });
    };

    const setCouponAmount = (amount) => {
        if (updateTimeout) {
            clearTimeout(updateTimeout);
        }
        updateTimeout = setTimeout(() => {
            cds('coupon/update', {
                method: 'POST',
                body: { amount: amount }
            }).then(json => {
                setCouponData(json);
            });
        }, 200);
        setAmount(amount);
    };

    const setCategory = (type) => {
        cds('coupon/update', {
            method: 'POST',
            body: { type: type }
        }).then(json => {
            setCouponData(json);
        });
    };

    useEffect(() => {

        emitter.on('openCoupon', () => {
            setOpened(true);
            emitter.emit('selectedMenu', 'coupon');
        });

        emitter.on('closeCoupon', () => {
            setOpened(false);
            emitter.emit('selectedMenu', 'previous');
        });

        // kupona bahis ekle
        emitter.on('addBet', (data) => {
            cds('coupon/create-bet', {
                method: 'POST',
                body: data
            }).then(json => {
                setCouponData(json);
            });
        });

        // kuponu getir
        initialTimeout = setTimeout(() => {
            cds('coupon/get').then(json => {
                setCouponData(json);
            });
        }, 300);

        // getInCoupon
        emitter.on('getInCoupon', () => {
            emitter.emit('inCoupon', inCoupon);
        });

        return () => {
            emitter.removeAllListeners('openCoupon');
            emitter.removeAllListeners('closeCoupon');
            emitter.removeAllListeners('addBet');
            emitter.removeAllListeners('getInCoupon');
            clearTimeout(initialTimeout);
        }

    }, []);

    useEffect(() => {
        function handleClickOutside(event) {
            if (settingsRef.current && !settingsRef.current.contains(event.target)) {
                setSettingsOpen(false);
            }
        }
        if (settingsOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [settingsOpen]);

    const handleRememberSelections = (checked) => {
        setRememberSelections(checked);
        localStorage.setItem('rememberSelections', checked);
    };
    const handleAcceptOddChanges = (checked) => {
        setAcceptOddChanges(checked);
        localStorage.setItem('acceptOddChanges', checked);
    };

    if (!data) {
        return <div>Loading...</div>;
    }

    const settingsMenu = (
        <div data-v-5d6fa4da="" className="flex border border-slate-300 drop-shadow-md">
            <div className="flex flex-col flex-wrap bg-white w-64">
                <div data-v-5d6fa4da="" className="flex items-center justify-between py-2 px-3">
                    <span data-v-5d6fa4da="" className="text-sm">
                        Seçimlerimi Hatırla
                    </span>
                    <Switch data-v-5d6fa4da="" className="css-q82w6o ant-switch-small" checked={rememberSelections} onChange={handleRememberSelections} size="small" />
                </div>
                <div data-v-5d6fa4da="" className="flex items-center justify-between py-2 px-3">
                    <span data-v-5d6fa4da="" className="text-sm">
                        Oran Değişikliklerini kabul et
                    </span>
                    <Switch data-v-5d6fa4da="" className="css-q82w6o ant-switch-small" checked={acceptOddChanges} onChange={handleAcceptOddChanges} size="small" />
                </div>
            </div>
        </div>
    );

    return (
        <div>
            {sticky ? '' : 
                <div className="flex justify-between p-3 text-white sticky top-0 z-10 bg-lightFour dark:bg-darkFour">
                    <div className="w1/3"></div>
                    <div className="w1/3 text-lg text-center">{trans('Kupon Sepeti')}</div>
                    <div className="w1/3 flex justify-end">
                        <div className="w-15 h-full flex justify-end">
                            <div className="i-tabler-chevrons-down bg-white w-6 h-6 text-end" onClick={() => emitter.emit('closeCoupon')}></div>
                        </div>
                    </div>
                </div>
            }
            {/* Ayarlar Popup */}
            {settingsOpen && (
                <div ref={settingsRef} className="absolute right-16 mt-2 bg-white border rounded shadow z-50 min-w-[220px]">
                    <div className="flex flex-col p-3 gap-2">
                        <div className="flex items-center justify-between">
                            <span>Seçimlerimi Hatırla</span>
                            <label className="switch">
                                <input type="checkbox" checked={rememberSelections} onChange={handleRememberSelections} />
                                <span className="slider round"></span>
                            </label>
                        </div>
                        <div className="flex items-center justify-between">
                            <span>Oran Değişikliklerini kabul et</span>
                            <label className="switch">
                                <input type="checkbox" checked={acceptOddChanges} onChange={handleAcceptOddChanges} />
                                <span className="slider round"></span>
                            </label>
                        </div>
                    </div>
                </div>
            )}
            {data.coupon.bets.length == 0 ?
                <CouponIsEmpty played={played} lastCouponId={lastCouponId} setCouponData={setCouponData} setPlayed={setPlayed} />
            :
            <div>
                <div className="ant-spin-nested-loading">
                    {playing ? <div>
                        <div className="ant-spin ant-spin-spinning">
                            <span className="ant-spin-dot ant-spin-dot-spin">
                                <i className="ant-spin-dot-item"></i>
                                <i className="ant-spin-dot-item"></i>
                                <i className="ant-spin-dot-item"></i>
                                <i className="ant-spin-dot-item"></i>
                            </span>
                        </div>
                    </div> : ''}
                    <div className={'ant-spin-container' + (playing ? ' ant-spin-blur' : '')}>
                        <div className="flex justify-between border-b-1 p-3 bg-white border-lightOne dark:bg-darkTwo dark:border-darkOne sticky top-48px z-10">
                            <Select value={data.coupon.type} style={{ width: 200 }} options={[
                                { value: 1, label: trans('Kombine') },
                                { value: 2, label: trans('Tekli') },
                                { value: 3, label: trans('Sistem') }
                            ]} onChange={(value) => setCategory(value)} />
                            <div className="flex flex-row justify-end">
                                {sticky ? '' :
                                <Link to="/basket" onClick={() => emitter.emit('closeCoupon')} className="flex items-center border border-gray-300 rounded px-2">
                                    <div className="i-tabler-window-maximize w-6 h-6 bg-gray-500"></div>
                                </Link>}
                                <Dropdown overlay={settingsMenu} trigger={['click']} placement="bottomRight" arrow>
                                    <div className="flex items-center border border-gray-300 rounded px-2 mx-1.5 ant-dropdown-trigger" style={{ cursor: 'pointer' }}>
                                        <div className="flex justify-center items-center w-6 h-6">
                                            <img className="w-5" src="/images/betslip/settings.svg" alt="Settings" />
                                        </div>
                                    </div>
                                </Dropdown>
                                <div className="flex items-center border border-gray-300 rounded px-2">
                                    <div className="flex justify-center items-center w-6 h-6" onClick={() => clearCoupon()}>
                                        <img className="w-3.75" src="/images/betslip/delete-betslip.svg" alt="Delete Betslip" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {data.coupon.bets.map((bet) =>
                        <div key={bet.event_id+'_'+bet.category_id+'_'+bet.option_id} className="flex items-center px-4 py-2 border-b bg-white border-lightOne dark:bg-darkTwo dark:border-darkOne">
                            <div className="flex flex-col justify-items-start items-center w-3/4 text-lightThree dark:text-darkThree">
                                <div className="flex w-full text-lg font-semibold">{bet.category_name} : {bet.option_name}</div>
                                <div className="flex w-full text-md text-[#4e4e4e] dark:text-gray-400">{bet.event_name}</div>
                                <div className="flex flex-row w-full items-center justify-items-start text-xs font-normal text-green-700">
                                    {bet.play_status != '0' ?
                                    <div className="flex flex-row text-textsecondary text-md">
                                        <span className="">{bet.play_time}'</span>
                                        <span className="px-1">|</span>
                                        <span className="font-semibold">{bet.play_score}</span>
                                        <span className="px-1">|</span>
                                    </div>
                                    : ''}
                                </div>
                            </div>
                            <div className="flex flex-row justify-end items-center w-1/4 py-1">
                                <div className="flex flex-row items-center text-lg font-semibold text-center text-lightThree dark:text-darkThree">
                                    {parseFloat(bet.odd).toFixed(2)}
                                </div>
                                <div className="flex w-6 h-8 items-center justify-end" onClick={() => deleteBet(bet.event_id, bet.category_id, bet.option_id)}>
                                    <div className="w-4 mt-0.5 i-tabler-x bg-gray-500"></div>
                                </div>
                            </div>
                        </div>
                        )}
                        <div className="flex flex-col text-lg font-semibold divide-y bg-lightTwo text-lightThree divide-lightOne dark:bg-darkTwo dark:text-darkThree dark:divide-darkOne">
                            <div className="flex justify-between px-3 py-2">
                                <div>{trans('Toplam Kupon Sayısı')}</div>
                                <div>{data.coupon.colons}</div>
                            </div>
                            <div className="flex justify-between px-3 py-2">
                                <div>{trans('Kupon Başına Bahis')}</div>
                                <div>{data.coupon.amount}</div>
                            </div>
                            <div className="flex justify-between px-3 py-2">
                                <div>{trans('Toplam Oran')}</div>
                                <div>{parseFloat(data.coupon.total_odd).toFixed(2)}</div>
                            </div>
                            <div className="flex justify-between px-3 py-2">
                                <div>{trans('Olası Maksimum Ödeme')}</div>
                                <div>{parseFloat(data.coupon.max_gain).toFixed(2)} TRY</div>
                            </div>
                        </div>
                        {/*<div className="flex justify-start items-center bg-[#28a95b] p-2 text-white gap-2">
                            <div className="i-tabler-award w-6 h-6"></div>
                            <span className="text-md">31 Bahis daha ekleyin ve Camila Cabello'yu kazanın</span>
                        </div>*/}
                        <div className="flex flex-col bg-lightTwo dark:bg-darkTwo">
                            <div className="flex flex-row items-center">
                                <div className="flex w-full justify-between items-center p-2 pb-0">
                                    <div className="flex flex-col w-2/5 items-center bg-white rounded border border-gray-400 px-2">
                                        <div className="flex flex-row items-center text-gray-500 pl-2">
                                            <span className="inline-block w-3/10 py-1 font-medium text-base">TRY</span>
                                            <input value={amount} onChange={(e) => setAmount(e.target.value)} onBlur={() => { if (amount != '') { setLastAmount(amount); setCouponAmount(amount) } else { setAmount(lastAmount); setCouponAmount(lastAmount) } }} onFocus={() => { setLastAmount(amount); setAmount('') }} className="font-semibold outline-none border-none pl-0 focus:border-none focus:outline-none focus:ring-none w-7/10 h-5" type="number" inputMode="decimal" />
                                        </div>
                                        <span className="flex w-full text-gray-400 leading-3 pl-1.5 pb-2.5">{trans('Toplam Bahis')}</span>
                                    </div>
                                    <div className="flex flex-col pr-2">
                                        <span className="flex justify-end text-green-600 font-medium text-base">{parseFloat(data.coupon.max_gain).toFixed(2)} TRY</span>
                                        <span className="flex justify-end text-gray-400 leading-3">{trans('Olası Maksimum Ödeme')}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="flex p-2">
                                <button onClick={() => play()} className="w-full rounded bg-[#28a95b] text-base font-medium text-white py-3">{data.coupon.amount} TRY {trans('Kuponu Onayla')}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>
    );
}

function CouponWrapper({ sticky = false }) {
    const [opened, setOpened] = useState(false);
    return (
        <div tabIndex="-1" className={'ant-drawer ant-drawer-bottom mb-12 flex w-full basket' + (opened ? ' ant-drawer-open' : '') + (sticky ? ' pt-12' : '')} style={{ zIndex: 90 }}>
            <div className="ant-drawer-mask"></div>
            <div className="ant-drawer-content-wrapper" style={{ height: sticky ? '100vh' : '70vh', transform: opened || sticky ? 'unset' : 'translateY(100%)' }}>
                <div className="ant-drawer-content">
                    <div className="ant-drawer-wrapper-body">
                        <div className="ant-drawer-body">
                            <div>
                                <Coupon setOpened={setOpened} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function CouponIsEmpty(params) {

    const reuseCoupon = () => {
        cds('coupon/reuse', {
            method: 'POST',
            body: { coupon_id: params.lastCouponId }
        }).then(json => {
            if (json.status === 'success') {
                params.setCouponData(json);
                params.setPlayed(false);
            } else {
                emitter.emit('error', json.message);
            }
        });
    };

    return (
        <div className="flex flex-col justify-start min-h-[calc(70vh)] p-3 bg-lightBg dark:bg-darkBg">
            {params.played ?
                <div class="flex flex-col w-full">
                    <div class="flex w-full items-center justify-center mb-3 mt-15">
                        <div class="flex w-18 h-18 items-center justify-center rounded-999 bg-[#28a95b]">
                            <div class="w-14 h-14 i-tabler-check bg-white"></div>
                        </div>
                    </div>
                    <div class="flex w-full items-center justify-center font-semibold mb-3">{trans('Kuponunuz onaylanmıştır, iyi şanslar dileriz.')}</div>
                    <div class="flex w-full items-center justify-center rounded bg-[#28a95b] text-base text-white font-medium mb-2 py-3" onClick={reuseCoupon}>{trans('Tekrar Kullan')}</div>
                </div>
            :
                <div className="flex flex-col w-full">
                    <div className="flex w-full items-center justify-center mb-3 mt-15">
                        <div className="w-24 h-24 i-tabler-receipt bg-gray-400 text-lg"></div>
                    </div>
                    <div className="flex w-full items-center justify-center font-medium text-xl ext-lightThree dark:text-darkThree">
                        {trans('Sepetinizde hiç bahis bulunmamaktadır.')}
                    </div>
                    <div className="flex w-full items-center justify-center text-gray-600 dark:text-gray-400">
                        {trans('Başlamak için popüler kategorilerimiz:')}
                    </div>
                </div>
            }
            <div className="mt-10 shadow-lg bg-lightTwo dark:bg-darkTwo">
                <Link to="/live" onClick={() => emitter.emit('closeCoupon')} className="">
                    <div className="flex justify-between items-center text-base pl-4 text-lightThree dark:text-darkThree">
                        <div className="flex items-center w-9 h-9 mr-4">
                            <img src="/images/menu/sondakika.svg" className="w-7 h-7 text-xl inline-block items-center" alt="Canlı Bahisler" />
                        </div>
                        <div className="flex w-full justify-start items-center border-b py-3.5 pr-3 border-lightOne dark:border-darkOne">
                            <div className="flex flex-col w-full">
                                <p className="w-full font-medium leading-4 m-0">{trans('Canlı Bahisler')}</p>
                            </div>
                            <div className="w-5 h-5 bg-gray-400 i-tabler-chevron-right"></div>
                        </div>
                    </div>
                </Link>
                <Link to="/prematch-menu/3" onClick={() => emitter.emit('closeCoupon')} className="">
                    <div className="flex justify-between items-center text-base pl-4 text-lightThree dark:text-darkThree">
                        <div className="flex relative items-center w-9 h-9 mr-4">
                            <img src="/images/menu/takvim.svg" className="w-7 h-7 text-xl inline-block items-center" alt="Bugün" />
                            <p className="items-center p-2 pt-6 text-sm text-black absolute">2</p>
                        </div>
                        <div className="flex w-full justify-start items-center border-b py-3.5 pr-3 border-lightOne dark:border-darkOne">
                            <div className="flex flex-col w-full">
                                <p className="w-full font-medium leading-4 m-0">{trans('Bugün')}</p>
                            </div>
                            <div className="w-6 h-6 bg-gray-400 i-tabler-chevron-right"></div>
                        </div>
                    </div>
                </Link>
                <Link to="/prematch-menu/2" onClick={() => emitter.emit('closeCoupon')} className="">
                    <div className="flex justify-between items-center text-base pl-4 text-lightThree dark:text-darkThree">
                        <div className="flex items-center w-9 h-9 mr-4">
                            <img src="/images/menu/last-3-hour.svg" className="w-7 h-7 text-xl inline-block items-center" alt="Son 3 Saat" />
                        </div>
                        <div className="flex w-full justify-start items-center border-b py-3.5 pr-3 border-lightOne dark:border-darkOne">
                            <div className="flex flex-col w-full">
                                <p className="w-full font-medium leading-4 m-0">{trans('Son 3 Saat')}</p>
                            </div>
                            <div className="w-6 h-6 bg-gray-400 i-tabler-chevron-right"></div>
                        </div>
                    </div>
                </Link>
                <Link to="/home" onClick={() => emitter.emit('closeCoupon')} className="router-link-active router-link-exact-active">
                    <div className="flex justify-between items-center text-base pl-4 text-lightThree dark:text-darkThree">
                        <div className="flex items-center w-9 h-9 mr-4">
                            <img src="/images/menu/best-matches.svg" className="w-7 h-7 text-xl inline-block items-center" alt="En İyi Bahisler" />
                        </div>
                        <div className="flex w-full justify-start items-center border-b py-3.5 pr-3 border-lightOne dark:border-darkOne">
                            <div className="flex flex-col w-full">
                                <p className="w-full font-medium leading-4 m-0">{trans('En İyi Bahisler')}</p>
                            </div>
                            <div className="w-6 h-6 bg-gray-400 i-tabler-chevron-right"></div>
                        </div>
                    </div>
                </Link>
                <Link to="/prematch-menu/0/1" onClick={() => emitter.emit('closeCoupon')} className="">
                    <div className="flex justify-between items-center text-base pl-4 text-lightThree dark:text-darkThree">
                        <div className="flex items-center w-9 h-9 mr-4">
                            <img src="/images/menu/spor-bahisleri.png" className="w-7 h-7 text-xl inline-block items-center" alt="Futbol" />
                        </div>
                        <div className="flex w-full justify-start items-center border-b py-3.5 pr-3 border-lightOne dark:border-darkOne">
                            <div className="flex flex-col w-full">
                                <p className="w-full font-medium leading-4 m-0">{trans('Futbol')}</p>
                            </div>
                            <div className="w-6 h-6 bg-gray-400 i-tabler-chevron-right"></div>
                        </div>
                    </div>
                </Link>
            </div>
        </div>
    )
}

export { Coupon, CouponWrapper };